import React from 'react';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setPluginDetails } from 'Workspace/Plugins/store/actions';
import { FormattedMessage } from 'react-intl';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';
import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection, action) {
  const workspacePluginDetails = yield call(connection.fetch.bind(connection), {
    type: constants.RTM_WORKSPACE_PLUGIN_DETAILS,
    pluginId: action.pluginId,
  });
  if (workspacePluginDetails.type === constants.RTM_WORKSPACE_PLUGIN_DETAILS_OK) {
    const pluginDetails = workspacePluginDetails.response.plugin;
    yield put(setPluginDetails(pluginDetails));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedWorkspacePluginDetailsFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_WORKSPACE_PLUGIN_DETAILS, catchErrors, sendRequest, connection);
}
